import { render, staticRenderFns } from "./AddCommentOnProductModal.vue?vue&type=template&id=2b871336&"
import script from "./AddCommentOnProductModal.vue?vue&type=script&lang=js&"
export * from "./AddCommentOnProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports